import { render, staticRenderFns } from "./Patient_.vue?vue&type=template&id=6eb35b37"
import script from "./Patient_.vue?vue&type=script&lang=js"
export * from "./Patient_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports